export default "__VITE_ASSET__N6c9nS9h__"